/* global axios */
import ApiClient from './ApiClient';

class InboxStorageConfig extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  getStorageConfig(inboxId) {
    return axios.get(`${this.url}/${inboxId}/storage_config`);
  }

  createStorageConfig(inboxId, data) {
    return axios.post(`${this.url}/${inboxId}/storage_config`, data);
  }

  updateStorageConfig(inboxId, data) {
    return axios.put(`${this.url}/${inboxId}/storage_config`, data);
  }

  testS3Config(inboxId, data) {
    return axios.post(`${this.url}/${inboxId}/storage_config/test`, data);
  }

  getEnvStorageConfig(inboxId) {
    return axios.get(`${this.url}/${inboxId}/storage_config/env_storage`);
  }
}

export default new InboxStorageConfig();
